export const STATUS_FETCHED = 'FETCHED';
export const STATUS_FETCHING = 'FETCHING';
export const STATUS_ERROR = 'ERROR';
